import {Sprite} from 'pixi.js';
import {CoinFlightConstants} from '@gongxigames/framework/slot/modules/buyBonus/coinFlight/CoinFlightConstants';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {CoreDI, ModuleIsEnabledFilter, Spine, SpineAnimation, UpdateManager, inject} from '@gongxigames/framework/core';
import {GameConfig, IReelsScaleService} from '@gongxigames/framework/slot/types';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {View} from '@gongxigames/framework/slot/fragments/module/view';

export class CoinFlightView extends View {
    public static readonly NAME: symbol = Symbol('CoinFlightView');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;
    public static layer = LAYERS.TOP;
    public static readonly FLIGHT_FINISHED: symbol = Symbol('FLIGHT_FINISHED');

    protected _animationContainer!: Sprite;
    protected _animations: SpineAnimation[] = [];
    protected _animation!: SpineAnimation;
    protected _animationPm!: SpineAnimation;
    protected _isPortrait = false;
    protected _updater: UpdateManager = new UpdateManager(true);

    @inject(DI.ReelsScaleService)
    protected _reelsScaleService!: IReelsScaleService;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    public init(): void {
        super.init();

        this.updateManager.add(this._updater);

        this._animationContainer = new Sprite();
        this.container.addChild(this._animationContainer);
    }

    public startFlightAnimation(rowIndex: number, rubyBalance: number): void {
        const {SPINE_NAME, WIDE_ANIMATION_NAME, WIDE_PM_ANIMATION_NAME} = CoinFlightConstants;

        this._animation = new SpineAnimation(this.objectBuilder.buildSpine(SPINE_NAME), WIDE_ANIMATION_NAME + `${rowIndex + 1}`);
        this._animations.push(this._animation);

        if (this.isPlatformMobile()) {
            this._animationPm = new SpineAnimation(this.objectBuilder.buildSpine(SPINE_NAME), WIDE_PM_ANIMATION_NAME + `${rowIndex + 1}`);
            this._animationPm.container.visible = false;
            this._animations.push(this._animationPm);
        }

        if (this._isPortrait) {
            this._animation.container.visible = false;
            this._animationPm.container.visible = true;
        }

        this._animations.forEach(animation => {
            this._animationContainer.addChild(animation.container);
            animation.container.x = this._gameConfig.mainFrame.width / 2;
            animation.container.y = this._gameConfig.mainFrame.height / 2;
            animation.start();

            const spine = animation.container as Spine;

            spine.state.addListener({
                event: () => {
                    this.emit(CoinFlightView.FLIGHT_FINISHED, rubyBalance);
                    this.reset();
                }
            });

            this._updater.add(animation);
        });
    }

    public playFlightSound(): void {
        this.soundPlayer.play('rubySymbolMove');
    }

    public reset(): void {
        this._animations.length = 0;
        this._updater.removeAll();
        this._animationContainer.removeChildren();
    }

    public onLandscape(): void {
        super.onLandscape();

        this._isPortrait = false;

        this._reelsScaleService.scaleByCurrentScreenOrientation(this.container);

        if (this._animationContainer.children.length) {
            this._animation.container.visible = true;
            this._animationPm.container.visible = false;
        }
    }

    public onPortrait(): void {
        super.onPortrait();

        this._isPortrait = true;

        this._reelsScaleService.scaleByCurrentScreenOrientation(this.container);

        if (this._animationContainer.children.length) {
            this._animation.container.visible = false;
            this._animationPm.container.visible = true;
        }
    }
}
